module.exports = __webpack_public_path__ + "img/logo.mincifra.95515c33.svg";